import { createSlice } from '@reduxjs/toolkit';

export interface ToggleState {
  open: boolean;
}
export type SidebarState = ToggleState;

const initialState: SidebarState = {
  open: false,
};

export const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.open = !state.open;
    },
  },
});

export const { toggleSidebar } = sidebarSlice.actions;
export default sidebarSlice.reducer;
